import StorageLogger from '@/core/services/StorageLogger'

export default {
    install (Vue) {
        Vue.prototype.$logger = StorageLogger
    }
}
